module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAAYklEQVRIie3NwQmAMAxG4Rcn6TxO0AEEwX0EwQk6geO0m8STUAverAf5v1tCyAMREZEHVg8ppRFYgfByp7j7EmM8rsXQHGwdogDBzPZ60YY/cwu7+wzkDp1sZlOHvyIi8kcnbSkQB2d6bG0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minus.png
// module id = E3Rp
// module chunks = 2